import React from "react";

// Gbuyers Privacy Policy - Play Store Ready (No HTML Download)
export default function PrivacyPolicy() {
  const effectiveDate = "13 Sep 2025";
  const supportEmail = "rajureddi60@gmail.com";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 flex justify-center">
      <div className="max-w-4xl w-full bg-white shadow-md rounded-lg p-6 md:p-10 text-left">
        {/* Header */}
        <header className="mb-6">
          <h1 className="text-2xl md:text-3xl font-semibold">
            Privacy Policy for <span className="text-indigo-600">Gbuyers</span>
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Effective Date: <strong>{effectiveDate}</strong>
          </p>
        </header>

        {/* Main Content */}
        <main className="text-left space-y-4">
          <p>
            Gbuyers ("we," "our," or "us") values your trust and is committed to
            protecting your personal information. This Privacy Policy explains
            how we collect, use, disclose, and safeguard the data you provide
            when using our mobile application <strong>Gbuyers</strong>, which
            enables users to sell gold, buy gold, and request doorstep services.
          </p>

          <h2 className="font-semibold text-lg">1. Information We Collect</h2>
          <p>We may collect the following information:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Personal Information:</strong> Name, phone number, email
              address, delivery/pickup address, and ID details.
            </li>
            <li>
              <strong>Transaction Details:</strong> Gold product details, order
              history, payment information.
            </li>
            <li>
              <strong>Device & Usage Data:</strong> Device model, operating
              system, app logs, crash reports.
            </li>
            <li>
              <strong>Location Data:</strong> With permission, we collect
              location data for doorstep services.
            </li>
            <li>
              <strong>Cookies & Tracking:</strong> We may use cookies or similar
              technologies to improve app experience.
            </li>
          </ul>

          <h2 className="font-semibold text-lg">2. How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To process gold selling and buying requests.</li>
            <li>To provide doorstep pick-up/delivery services.</li>
            <li>To verify identity as required by law.</li>
            <li>To send updates, confirmations, or support messages.</li>
            <li>To improve functionality, security, and user experience.</li>
            <li>To comply with legal obligations and prevent fraud.</li>
          </ul>

          <h2 className="font-semibold text-lg">3. Data Sharing and Disclosure</h2>
          <p>We do not sell your personal data. However, we may share information with:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Service Providers:</strong> For payments, logistics, and
              verification.
            </li>
            <li>
              <strong>Legal Authorities:</strong> When required to comply with
              law or protect against fraud.
            </li>
            <li>
              <strong>Business Transfers:</strong> If Gbuyers is involved in a
              merger, acquisition, or sale of assets.
            </li>
          </ul>

          <h2 className="font-semibold text-lg">4. Data Retention</h2>
          <p>
            We retain your personal data only as long as necessary for legal,
            regulatory, or business purposes. When data is no longer required,
            we securely delete it.
          </p>

          <h2 className="font-semibold text-lg">5. International Data Transfers</h2>
          <p>
            Your data may be transferred and stored on servers outside your
            country. We ensure adequate protection measures are applied.
          </p>

          <h2 className="font-semibold text-lg">6. Data Security</h2>
          <p>
            We implement security measures to protect data from unauthorized
            access, alteration, or disclosure. However, no method of
            transmission over the internet is 100% secure.
          </p>

          <h2 className="font-semibold text-lg">7. Your Rights</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Access, update, or delete your personal data.</li>
            <li>
              Withdraw consent for location/contact data anytime via settings.
            </li>
            <li>Opt-out of marketing communications.</li>
            <li>Request a copy of the data we hold about you.</li>
          </ul>

          <h2 className="font-semibold text-lg">8. Children’s Privacy</h2>
          <p>
            Our app is not directed at children under 18, and we do not knowingly
            collect data from minors.
          </p>

          <h2 className="font-semibold text-lg">9. Third-Party Links</h2>
          <p>
            Our app may contain links to external sites. We are not responsible
            for their privacy practices.
          </p>

          <h2 className="font-semibold text-lg">10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy occasionally. Updates will be
            posted within the app or via a new link. Please review regularly.
          </p>

          <h2 className="font-semibold text-lg">11. Contact Us</h2>
          <p>
            <strong>Gbuyers Support</strong>
            <br />
            Email: {supportEmail}
          </p>

          {/* New Section: Account Deletion Request */}
          <h2 className="font-semibold text-lg">12. Account Deletion Request</h2>
          <p>To request deletion of your Gbuyers account and personal data, please follow these steps:</p>
          <ol className="list-decimal pl-6 space-y-1">
            <li>Send an email to: {supportEmail}</li>
            <li>Include your full name, registered email, and phone number associated with your account.</li>
            <li>Your personal data will be deleted, including name, email, phone number, shipping/billing addresses, and usage data.</li>
            <li>Some data may be retained for legal or compliance purposes (such as payment or transaction records).</li>
          </ol>
        </main>
      </div>
    </div>
  );
}
